import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Globe, Users, Sparkles } from "lucide-react";
import Layout from "@/components/layout/Layout";
import { CAREERS } from "@/lib/data";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function Careers() {
  return (
    <Layout>
      <section className="py-28 border-b border-white/10" data-testid="careers-hero">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <span className="eyebrow">Careers</span>
          <h1 className="heading-massive mt-4">
            Build the <span className="text-tratou-green">post-diesel</span> economy.
          </h1>
          <p className="mt-8 max-w-2xl text-tratou-dim text-lg">
            Join a team replacing 100 years of fossil-fuel-on-wheels with silent, intelligent,
            mobile electricity. Hardware. Software. Operations. Sales.
          </p>
        </div>
      </section>

      <section className="py-24" data-testid="careers-values">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid md:grid-cols-3 gap-px bg-white/10 border border-white/10">
          <ValueCard icon={Sparkles} title="Engineering First" body="Hardware × software × deployment. We ship MBESS fleets and the software that runs them." />
          <ValueCard icon={Users} title="High-Trust, Low-Overhead" body="No meetings theatre. Clear specs, async-first, asset utilisation > status updates." />
          <ValueCard icon={Globe} title="Global from Day One" body="Pilots in UAE, KSA, Egypt, India. Field-ops culture: travel, deploy, learn, return." />
        </div>
      </section>

      <section className="py-24 border-t border-white/10" data-testid="careers-openings">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <span className="eyebrow">Open Roles</span>
          <h2 className="heading-section mt-4">{CAREERS.length} positions open.</h2>

          <Accordion type="single" collapsible className="mt-10 panel divide-y divide-white/5">
            {CAREERS.map((r, i) => (
              <AccordionItem key={r.title} value={`r-${i}`} className="border-0" data-testid={`role-${i}`}>
                <AccordionTrigger className="px-6 py-5 hover:no-underline">
                  <div className="flex flex-1 items-center justify-between gap-6 text-left">
                    <span className="font-display font-bold text-lg">{r.title}</span>
                    <span className="font-mono text-[11px] uppercase tracking-[0.18em] text-tratou-dim">
                      {r.location} · {r.type}
                    </span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="px-6 pb-6 text-tratou-dim">
                  <p>We're looking for a {r.title.toLowerCase()} to join the Tratou Energy team. You will work alongside our engineering and operations team to scale our MBESS fleet across {r.location}. Strong ownership, hands-on disposition, and a track record of shipping in fast-moving environments.</p>
                  <Link
                    to={`/contact?intent=career&role=${encodeURIComponent(r.title)}`}
                    className="btn-primary mt-5 inline-flex"
                    data-testid={`role-apply-${i}`}
                  >
                    Apply Now <ArrowRight className="w-4 h-4" />
                  </Link>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
    </Layout>
  );
}

function ValueCard({ icon: Icon, title, body }) {
  return (
    <div className="bg-tratou-deep p-8 panel-hover">
      <Icon className="w-7 h-7 text-tratou-green mb-5" />
      <h3 className="font-display font-bold text-xl">{title}</h3>
      <p className="mt-3 text-tratou-dim">{body}</p>
    </div>
  );
}
